import { DATA_TYPES } from "./data_types.js"
import public_private from "./public_private.js"
import input_types from "./input_types.js"
import currencies from "./currencies.js"
import formula_types from "./formula_types"
import formulary_options from "./formulary_options.js"
import { PAGE_REFERENCES, VIEW_TYPES, MODULES } from "./references"
import { ACTIVITIES_HEADERS, INTERACTIONS_HEADERS } from "./headers.js"

class Constants {
  constructor(data) {
    this.data = data
    if (Array.isArray(data)) {
      Object.defineProperty(this, "items", {
        value: data,
        writable: false
      })
      Object.defineProperty(this, "values", {
        value: data.map((x) => x.value),
        writable: false
      })

      data.forEach((item) => {
        Object.defineProperty(this, item.label, {
          value: item,
          writable: false,
          enumerable: true
        })
        try {
          Object.defineProperty(this, item.value, {
            value: item,
            writable: false,
            enumerable: true
          })
        } catch (_) {
          //
        }
      })
    } else {
      for (const [key, value] of Object.entries(data)) {
        Object.defineProperty(this, key, {
          value: value,
          writable: false
        })
        Object.defineProperty(this, key.toLowerCase(), {
          value: value,
          writable: false
        })
      }
    }
  }
}

class Consts {
  static FORMULA_TYPES = formula_types
  static page_references = new Constants(PAGE_REFERENCES)
  static view_types = new Constants(VIEW_TYPES)
  static modules = new Constants(MODULES)

  static currencies = new Constants(currencies)
  static data_types = new Constants(DATA_TYPES)
  static input_types = new Constants(input_types)
  static public_private = public_private
  static formulary_options = new Constants(formulary_options)

  //upper case
  static PAGE_REFERENCES = new Constants(PAGE_REFERENCES)
  static VIEW_TYPES = new Constants(VIEW_TYPES)
  static MODULES = new Constants(MODULES)

  static CURRENCIES = new Constants(currencies)
  static DATA_TYPES = DATA_TYPES
  static curr = currencies
  static INPUT_TYPES = new Constants(input_types)
  static ACTIVITIES_HEADERS = ACTIVITIES_HEADERS
  static INTERACTIONS_HEADERS = INTERACTIONS_HEADERS

  static FORMULARY_OPTIONS = formulary_options
  static FORMULARY_OPTIONS_NO_NUMBERS = new Constants(formulary_options.filter((option) => option.type != "number"))
  static FORMULARY_OPTIONS_NO_MORE = formulary_options.filter((option) => !option?.more)
}

export const consts = Consts
